import { EnglishOffline } from '../../interfaces/cards.interface';

export const ENGLISH_CARD: EnglishOffline[] = [
    {
        name: 'c1',
        word: '{"en":"Lollipop","vi":"Kẹo mút"}',
        path: 'candy/Lollipop.png',
        level: '1',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 1,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'c2',
        word: '{"en":"Bread","vi":"Bánh mỳ"}',
        path: 'candy/Bread.png',
        level: '2',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 2,
        createdAt: '2019-09-24T12:11:25.000Z',
        updatedAt: '2019-09-28T04:41:20.000Z'
    },
    {
        name: 'c3',
        word: '{"en":"Jelly","vi":"Thạch"}',
        path: 'candy/Jelly.png',
        level: '3',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 3,
        createdAt: '2019-09-25T04:17:06.000Z',
        updatedAt: '2019-09-28T04:41:59.000Z'
    },
    {
        name: 'c4',
        word: '{"en":"Birthday cake","vi":"Bánh sinh nhật"}',
        path: 'candy/Birthday_cake.png',
        level: '4',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 4,
        createdAt: '2019-09-28T04:42:28.000Z',
        updatedAt: '2019-09-28T04:42:28.000Z'
    },
    {
        name: 'c5',
        word: '{"en":"Moon cake","vi":"Bánh trung thu"}',
        path: 'candy/Moon_cake.png',
        level: '5',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 5,
        createdAt: '2019-09-28T04:43:13.000Z',
        updatedAt: '2019-09-28T04:43:13.000Z'
    },
    {
        name: 'c6',
        word: '{"en":"Swirl lollipop","vi":"Kẹo mút xoáy"}',
        path: 'candy/Swirl_lollipop.png',
        level: '6',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 6,
        createdAt: '2019-09-28T04:43:43.000Z',
        updatedAt: '2019-09-28T04:43:43.000Z'
    },
    {
        name: 'c7',
        word: '{"en":"Jelly beans","vi":"Kẹo hình hạt đậu"}',
        path: 'candy/Jelly_beans.png',
        level: '7',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 7,
        createdAt: '2019-09-28T04:44:12.000Z',
        updatedAt: '2019-09-28T04:44:12.000Z'
    },
    {
        name: 'c8',
        word: '{"en":"Fruit drops","vi":"Kẹo trái cây"}',
        path: 'candy/Fruit_drops.png',
        level: '8',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 8,
        createdAt: '2019-09-28T04:44:49.000Z',
        updatedAt: '2019-09-28T04:44:49.000Z'
    },
    {
        name: 'c9',
        word: '{"en":"Jam cookies","vi":"Bánh mứt"}',
        path: 'candy/Jam_cookies.png',
        level: '9',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 9,
        createdAt: '2019-09-28T04:46:46.000Z',
        updatedAt: '2019-09-28T04:46:46.000Z'
    },
    {
        name: 'c10',
        word: '{"en":"Hard Candy","vi":"Kẹo cứng"}',
        path: 'candy/Hard_Candy.png',
        level: '10',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 10,
        createdAt: '2019-09-28T04:47:08.000Z',
        updatedAt: '2019-09-28T04:47:08.000Z'
    },
    {
        name: 'c11',
        word: '{"en":"Rice cracker","vi":"Bánh gạo"}',
        path: 'candy/Rice_cracker.png',
        level: '11',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 11,
        createdAt: '2019-09-28T04:47:37.000Z',
        updatedAt: '2019-09-28T04:47:37.000Z'
    },
    {
        name: 'c12',
        word: '{"en":"Chocolate bar","vi":"Thanh sô-cô-la"}',
        path: 'candy/Chocolate_bar.png',
        level: '12',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 12,
        createdAt: '2019-09-28T04:48:06.000Z',
        updatedAt: '2019-09-28T04:48:06.000Z'
    },
    {
        name: 'c13',
        word: '{"en":"Candy Cane","vi":"Kẹo gậy"}',
        path: 'candy/Candy_Cane.png',
        level: '13',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 13,
        createdAt: '2019-09-28T04:48:29.000Z',
        updatedAt: '2019-09-28T04:48:29.000Z'
    },
    {
        name: 'c14',
        word: '{"en":"Caramel Pudding","vi":"Caramen"}',
        path: 'candy/Caramel_Pudding.png',
        level: '14',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 14,
        createdAt: '2019-09-28T04:48:59.000Z',
        updatedAt: '2019-09-28T04:48:59.000Z'
    },
    {
        name: 'c15',
        word: '{"en":"Strawberry cake","vi":"Bánh dâu tây"}',
        path: 'candy/Strawberry_cake.png',
        level: '15',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 15,
        createdAt: '2019-09-28T04:49:26.000Z',
        updatedAt: '2019-09-28T04:49:26.000Z'
    },
    {
        name: 'c16',
        word: '{"en":"Pop corn","vi":"Bỏng ngô"}',
        path: 'candy/Pop_corn.png',
        level: '16',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 16,
        createdAt: '2019-09-28T04:49:53.000Z',
        updatedAt: '2019-09-28T04:49:53.000Z'
    },
    {
        name: 'c17',
        word: '{"en":"Potato chips","vi":"Bim bim khoai tây"}',
        path: 'candy/Potato_chips.png',
        level: '17',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 17,
        createdAt: '2019-09-28T04:50:22.000Z',
        updatedAt: '2019-09-28T04:50:22.000Z'
    },
    {
        name: 'c19',
        word: '{"en":"Blueberry cake","vi":"Bánh việt quất"}',
        path: 'candy/Blueberry_cake.png',
        level: '19',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 18,
        createdAt: '2019-09-28T04:50:49.000Z',
        updatedAt: '2019-09-28T04:50:49.000Z'
    },
    {
        name: 'c18',
        word: '{"en":"Cotton Candy","vi":"Kẹo bông gòn"}',
        path: 'candy/Cotton_Candy.png',
        level: '18',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 19,
        createdAt: '2019-09-28T04:51:16.000Z',
        updatedAt: '2019-09-28T04:51:16.000Z'
    },
    {
        name: 'c20',
        word: '{"en":"Marshmallow","vi":"Kẹo xốp dẻo"}',
        path: 'candy/Marshmallow.png',
        level: '20',
        map: '1',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 20,
        createdAt: '2019-09-28T04:51:52.000Z',
        updatedAt: '2019-09-28T04:51:52.000Z'
    },
    {
        name: 'c21',
        word: '{"en":"Pizza","vi":"Bánh pizza"}',
        path: 'candy/Pizza.png',
        level: '1',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 21,
        createdAt: '2019-09-28T04:53:02.000Z',
        updatedAt: '2019-09-28T04:53:02.000Z'
    },
    {
        name: 'c22',
        word: '{"en":"Cupcake","vi":"Bánh nướng nhỏ"}',
        path: 'candy/Cupcake.png',
        level: '2',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 22,
        createdAt: '2019-09-28T04:54:15.000Z',
        updatedAt: '2019-09-28T04:54:15.000Z'
    },
    {
        name: 'c23',
        word: '{"en":"Biscuit","vi":"Bánh quy"}',
        path: 'candy/Biscuit.png',
        level: '3',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 23,
        createdAt: '2019-09-28T04:54:40.000Z',
        updatedAt: '2019-09-28T04:54:40.000Z'
    },
    {
        name: 'c24',
        word: '{"en":"Chocolate Chip Cookies","vi":"Bánh quy sô cô la viên"}',
        path: 'candy/Chocolate_Chip_Cookies.png',
        level: '4',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 24,
        createdAt: '2019-09-28T04:55:07.000Z',
        updatedAt: '2019-09-28T04:55:07.000Z'
    },
    {
        name: 'c25',
        word: '{"en":"Macaroons","vi":"Bánh macaroon"}',
        path: 'candy/Macaroons.png',
        level: '5',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 25,
        createdAt: '2019-09-28T04:56:27.000Z',
        updatedAt: '2019-09-28T04:56:27.000Z'
    },
    {
        name: 'c26',
        word: '{"en":"Egg tart","vi":"Bánh trứng"}',
        path: 'candy/Egg_tart.png',
        level: '6',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 26,
        createdAt: '2019-09-28T04:57:14.000Z',
        updatedAt: '2019-09-28T04:57:14.000Z'
    },
    {
        name: 'c27',
        word: '{"en":"Durian cake","vi":"Bánh sầu riêng"}',
        path: 'candy/Durian_cake.png',
        level: '7',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 27,
        createdAt: '2019-09-28T04:57:36.000Z',
        updatedAt: '2019-09-28T04:57:36.000Z'
    },
    {
        name: 'c28',
        word: '{"en":"Blueberry cupcake","vi":"Bánh việt quất nhỏ"}',
        path: 'candy/Blueberry_cupcake.png',
        level: '8',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 28,
        createdAt: '2019-09-28T04:58:00.000Z',
        updatedAt: '2019-09-28T04:58:00.000Z'
    },
    {
        name: 'c29',
        word: '{"en":"Pancake","vi":"Bánh bột mì mỏng"}',
        path: 'candy/Pancake.png',
        level: '9',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 29,
        createdAt: '2019-09-28T04:58:27.000Z',
        updatedAt: '2019-09-28T04:58:27.000Z'
    },
    {
        name: 'c30',
        word: '{"en":"Open","vi":"Mở/Há"}',
        path: 'candy/Open.png',
        level: '10',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 30,
        createdAt: '2019-09-28T04:59:06.000Z',
        updatedAt: '2019-09-28T04:59:06.000Z'
    },
    {
        name: 'c31',
        word: '{"en":"Banana dried","vi":"Chuối sấy"}',
        path: 'candy/Banana_dried.png',
        level: '11',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 31,
        createdAt: '2019-09-28T04:59:32.000Z',
        updatedAt: '2019-09-28T04:59:32.000Z'
    },
    {
        name: 'c32',
        word: '{"en":"Watermelon jelly","vi":"Thạch dưa hấu"}',
        path: 'candy/Watermelon_jelly.png',
        level: '12',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 32,
        createdAt: '2019-09-28T05:00:19.000Z',
        updatedAt: '2019-09-28T05:00:19.000Z'
    },
    {
        name: 'c33',
        word: '{"en":"Chocolate cake","vi":"Bánh sô cô la"}',
        path: 'candy/Chocolate_cake.png',
        level: '13',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 33,
        createdAt: '2019-09-28T05:00:46.000Z',
        updatedAt: '2019-09-28T05:00:46.000Z'
    },
    {
        name: 'c34',
        word: '{"en":"Crisp Cake","vi":""}',
        path: 'candy/Crisp_Cake.png',
        level: '14',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 34,
        createdAt: '2019-09-28T05:01:23.000Z',
        updatedAt: '2019-09-28T05:01:23.000Z'
    },
    {
        name: 'c35',
        word: '{"en":"Hold","vi":"Cầm"}',
        path: 'candy/Hold.png',
        level: '15',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 35,
        createdAt: '2019-09-28T05:01:48.000Z',
        updatedAt: '2019-09-28T05:01:48.000Z'
    },
    {
        name: 'c36',
        word: '{"en":"Sponge cake","vi":"Bánh bọt biển"}',
        path: 'candy/Sponge_cake.png',
        level: '16',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 36,
        createdAt: '2019-09-28T05:02:18.000Z',
        updatedAt: '2019-09-28T05:02:18.000Z'
    },
    {
        name: 'c37',
        word: '{"en":"Rainbow bean biscuit","vi":""}',
        path: 'candy/Rainbow_bean_biscuit.png',
        level: '17',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 37,
        createdAt: '2019-09-28T05:02:44.000Z',
        updatedAt: '2019-09-28T05:02:44.000Z'
    },
    {
        name: 'c38',
        word: '{"en":"Cat ear snacks","vi":"Bánh tai mèo"}',
        path: 'candy/Cat_ear_snacks.png',
        level: '18',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 38,
        createdAt: '2019-09-28T05:03:05.000Z',
        updatedAt: '2019-09-28T05:03:05.000Z'
    },
    {
        name: 'c39',
        word: '{"en":"Chinese dumplings","vi":"Sủi cảo"}',
        path: 'candy/Chinese_dumplings.png',
        level: '19',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 39,
        createdAt: '2019-09-28T05:03:33.000Z',
        updatedAt: '2019-09-28T05:03:33.000Z'
    },
    {
        name: 'c40',
        word: '{"en":"Blow","vi":"Thổi"}',
        path: 'candy/Blow.png',
        level: '20',
        map: '5',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 40,
        createdAt: '2019-09-28T05:03:55.000Z',
        updatedAt: '2019-09-28T05:03:55.000Z'
    },
    {
        name: 'c41',
        word: '{"en":"Sandwich","vi":"Bánh mì kẹp"}',
        path: 'candy/Sandwich.png',
        level: '1',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 41,
        createdAt: '2019-09-28T06:05:54.000Z',
        updatedAt: '2019-09-28T06:05:54.000Z'
    },
    {
        name: 'c42',
        word: '{"en":"Buns","vi":"Bánh bao"}',
        path: 'candy/Buns.png',
        level: '2',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 42,
        createdAt: '2019-09-28T06:06:24.000Z',
        updatedAt: '2019-09-28T06:06:24.000Z'
    },
    {
        name: 'c43',
        word: '{"en":"Jam","vi":"Mứt"}',
        path: 'candy/Jam.png',
        level: '3',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 43,
        createdAt: '2019-09-28T06:08:15.000Z',
        updatedAt: '2019-09-28T06:08:15.000Z'
    },
    {
        name: 'c44',
        word: '{"en":"Cracker","vi":"Bánh lạt"}',
        path: 'candy/Cracker.png',
        level: '4',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 44,
        createdAt: '2019-09-28T06:09:31.000Z',
        updatedAt: '2019-09-28T06:09:31.000Z'
    },
    {
        name: 'c45',
        word: '{"en":"Waffle","vi":"Bánh quế"}',
        path: 'candy/Waffle.png',
        level: '5',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 45,
        createdAt: '2019-09-28T06:10:13.000Z',
        updatedAt: '2019-09-28T06:10:13.000Z'
    },
    {
        name: 'c46',
        word: '{"en":"Strawberry candy","vi":"Kẹo dâu"}',
        path: 'candy/Strawberry_candy.png',
        level: '6',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 46,
        createdAt: '2019-09-28T06:10:39.000Z',
        updatedAt: '2019-09-28T06:10:39.000Z'
    },
    {
        name: 'c47',
        word: '{"en":"Gingerbread","vi":"Bánh gừng"}',
        path: 'candy/Gingerbread.png',
        level: '7',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 47,
        createdAt: '2019-09-28T06:11:56.000Z',
        updatedAt: '2019-10-07T08:52:38.000Z'
    },
    {
        name: 'c48',
        word: '{"en":"Delicious","vi":"Ngon miệng"}',
        path: 'candy/Delicious.png',
        level: '8',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 48,
        createdAt: '2019-09-28T06:12:24.000Z',
        updatedAt: '2019-09-28T06:12:24.000Z'
    },
    {
        name: 'c49',
        word: '{"en":"Chew","vi":"Kẹo mềm"}',
        path: 'candy/Chew.png',
        level: '9',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 49,
        createdAt: '2019-09-28T06:12:56.000Z',
        updatedAt: '2019-09-28T06:12:56.000Z'
    },
    {
        name: 'c50',
        word: '{"en":"Fudge","vi":"Kẹo dẻo"}',
        path: 'candy/Fudge.png',
        level: '10',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 50,
        createdAt: '2019-09-28T06:13:25.000Z',
        updatedAt: '2019-09-28T06:13:25.000Z'
    },
    {
        name: 'c51',
        word: '{"en":"Corn candy","vi":"Kẹo ngô"}',
        path: 'candy/Corn_candy.png',
        level: '11',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 51,
        createdAt: '2019-09-28T06:13:57.000Z',
        updatedAt: '2019-09-28T06:13:57.000Z'
    },
    {
        name: 'c52',
        word: '{"en":"Cheesecake","vi":"Bánh Pho mát"}',
        path: 'candy/Cheesecake.png',
        level: '12',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 52,
        createdAt: '2019-09-28T06:14:18.000Z',
        updatedAt: '2019-09-28T06:14:18.000Z'
    },
    {
        name: 'c53',
        word: '{"en":"Butter cookies","vi":"Bánh quy bơ"}',
        path: 'candy/Butter_cookies.png',
        level: '13',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 53,
        createdAt: '2019-09-28T06:14:52.000Z',
        updatedAt: '2019-09-28T06:14:52.000Z'
    },
    {
        name: 'c54',
        word: '{"en":"Muffin","vi":"Bánh nướng xốp"}',
        path: 'candy/Muffin.png',
        level: '14',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 54,
        createdAt: '2019-09-28T06:15:27.000Z',
        updatedAt: '2019-09-28T06:15:27.000Z'
    },
    {
        name: 'c55',
        word: '{"en":"Candied Hawthorn","vi":"Kẹo hồ lô"}',
        path: 'candy/Candied_Hawthorn.png',
        level: '15',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 55,
        createdAt: '2019-09-28T06:15:55.000Z',
        updatedAt: '2019-09-28T06:15:55.000Z'
    },
    {
        name: 'c56',
        word: '{"en":"Hamburgers","vi":"Bánh kẹp thịt"}',
        path: 'candy/Hamburgers.png',
        level: '16',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 56,
        createdAt: '2019-09-28T06:18:00.000Z',
        updatedAt: '2019-09-28T06:18:00.000Z'
    },
    {
        name: 'c57',
        word: '{"en":"Break","vi":"Vỡ"}',
        path: 'candy/Break.png',
        level: '17',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 57,
        createdAt: '2019-09-28T06:18:40.000Z',
        updatedAt: '2019-09-28T06:18:40.000Z'
    },
    {
        name: 'c58',
        word: '{"en":"Flan pudding","vi":"Bánh Flan"}',
        path: 'candy/Flan_pudding.png',
        level: '18',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 58,
        createdAt: '2019-09-28T06:19:04.000Z',
        updatedAt: '2019-09-28T06:19:04.000Z'
    },
    {
        name: 'c59',
        word: '{"en":"Coffee candy","vi":"Kẹo cà phê"}',
        path: 'candy/Coffee_candy.png',
        level: '19',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 59,
        createdAt: '2019-09-28T06:19:24.000Z',
        updatedAt: '2019-09-28T06:19:24.000Z'
    },
    {
        name: 'c60',
        word: '{"en":"Gummy bears","vi":"Kẹo gấu"}',
        path: 'candy/Gummy_bears.png',
        level: '20',
        map: '4',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 60,
        createdAt: '2019-09-28T06:19:49.000Z',
        updatedAt: '2019-09-28T06:19:49.000Z'
    },
    {
        name: 'c61',
        word: '{"en":"Donut","vi":"Bánh đô-nắt"}',
        path: 'candy/Donut.png',
        level: '1',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 61,
        createdAt: '2019-09-28T06:20:17.000Z',
        updatedAt: '2019-09-28T06:20:17.000Z'
    },
    {
        name: 'c62',
        word: '{"en":"Gingerbread house","vi":"Nhà bánh gừng"}',
        path: 'candy/Gingerbread_house.png',
        level: '2',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 62,
        createdAt: '2019-09-28T06:20:38.000Z',
        updatedAt: '2019-09-28T06:22:32.000Z'
    },
    {
        name: 'c63',
        word: '{"en":"Mints","vi":"Kẹo bạc hà"}',
        path: 'candy/Mints.png',
        level: '3',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 63,
        createdAt: '2019-09-28T06:21:11.000Z',
        updatedAt: '2019-09-28T06:21:11.000Z'
    },
    {
        name: 'c64',
        word: '{"en":"Croissant","vi":"Bánh sừng bò"}',
        path: 'candy/Croissant.png',
        level: '4',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 64,
        createdAt: '2019-09-28T06:21:52.000Z',
        updatedAt: '2019-09-28T06:21:52.000Z'
    },
    {
        name: 'c65',
        word: '{"en":"Lemon cake","vi":"Bánh kem chanh"}',
        path: 'candy/Lemon_cake.png',
        level: '5',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 65,
        createdAt: '2019-09-28T06:22:17.000Z',
        updatedAt: '2019-09-28T06:22:17.000Z'
    },
    {
        name: 'c66',
        word: '{"en":"Tasty","vi":"Ngon"}',
        path: 'candy/Tasty.png',
        level: '6',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 66,
        createdAt: '2019-09-28T06:23:13.000Z',
        updatedAt: '2019-09-28T06:23:13.000Z'
    },
    {
        name: 'c67',
        word: '{"en":"Eclairs","vi":"Bánh pháp eclairs"}',
        path: 'candy/Eclairs.png',
        level: '7',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 67,
        createdAt: '2019-09-28T06:23:39.000Z',
        updatedAt: '2019-09-28T06:23:39.000Z'
    },
    {
        name: 'c68',
        word: '{"en":"Roll cake","vi":"Bánh cuộn"}',
        path: 'candy/Roll_cake.png',
        level: '8',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 68,
        createdAt: '2019-09-28T06:24:07.000Z',
        updatedAt: '2019-09-28T06:24:07.000Z'
    },
    {
        name: 'c69',
        word: '{"en":"Popsicle","vi":"Kem que"}',
        path: 'candy/Popsicle.png',
        level: '9',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 69,
        createdAt: '2019-09-28T06:24:32.000Z',
        updatedAt: '2019-09-28T06:24:32.000Z'
    },
    {
        name: 'c70',
        word: '{"en":"Crepe","vi":"Bánh kếp"}',
        path: 'candy/Crepe.png',
        level: '10',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 70,
        createdAt: '2019-09-28T06:24:55.000Z',
        updatedAt: '2019-09-28T06:24:55.000Z'
    },
    {
        name: 'c71',
        word: '{"en":"BATTENBERG","vi":""}',
        path: 'candy/Battenberg.png',
        level: '11',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 71,
        createdAt: '2019-09-28T06:25:15.000Z',
        updatedAt: '2019-09-28T06:25:35.000Z'
    },
    {
        name: 'c72',
        word: '{"en":"Orange cake","vi":"Bánh cam"}',
        path: 'candy/Orange_cake.png',
        level: '12',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 72,
        createdAt: '2019-09-28T06:26:01.000Z',
        updatedAt: '2019-09-28T06:26:01.000Z'
    },
    {
        name: 'c73',
        word: '{"en":"Ice cream","vi":"Kem"}',
        path: 'candy/Ice_cream.png',
        level: '13',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 73,
        createdAt: '2019-09-28T06:26:28.000Z',
        updatedAt: '2019-09-28T06:26:28.000Z'
    },
    {
        name: 'c74',
        word: '{"en":"Creampuff","vi":"Bánh su kem"}',
        path: 'candy/Creampuff.png',
        level: '14',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 74,
        createdAt: '2019-09-28T06:28:06.000Z',
        updatedAt: '2019-09-28T06:32:30.000Z'
    },
    {
        name: 'c75',
        word: '{"en":"Tiramisu","vi":"Bánh Tiramisu"}',
        path: 'candy/Tiramisu.png',
        level: '15',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 75,
        createdAt: '2019-09-28T06:28:31.000Z',
        updatedAt: '2019-09-28T06:32:36.000Z'
    },
    {
        name: 'c76',
        word: '{"en":"Goldfish crackers","vi":"Bánh cá vàng"}',
        path: 'candy/Goldfish_crackers.png',
        level: '16',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 76,
        createdAt: '2019-09-28T06:28:52.000Z',
        updatedAt: '2019-09-28T06:32:42.000Z'
    },
    {
        name: 'c77',
        word: '{"en":"Pretzel","vi":"Quẩy"}',
        path: 'candy/Pretzel.png',
        level: '17',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 77,
        createdAt: '2019-09-28T06:29:15.000Z',
        updatedAt: '2019-09-28T06:32:53.000Z'
    },
    {
        name: 'c78',
        word: '{"en":"Orange lollipop","vi":"Kẹo mút cam"}',
        path: 'candy/Orange_lollipop.png',
        level: '18',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 78,
        createdAt: '2019-09-28T06:29:38.000Z',
        updatedAt: '2019-09-28T06:33:00.000Z'
    },
    {
        name: 'c79',
        word: '{"en":"Choux cream","vi":"Bánh kem nhật"}',
        path: 'candy/Choux_cream.png',
        level: '19',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 79,
        createdAt: '2019-09-28T06:30:05.000Z',
        updatedAt: '2019-09-28T06:33:07.000Z'
    },
    {
        name: 'c80',
        word: '{"en":"Swiss roll","vi":"Bánh kem cuộn"}',
        path: 'candy/Swiss_roll.png',
        level: '20',
        map: '3',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 80,
        createdAt: '2019-09-28T06:30:34.000Z',
        updatedAt: '2019-09-28T06:33:14.000Z'
    },
    {
        name: 'c81',
        word: '{"en":"Wafer","vi":"Bánh xốp"}',
        path: 'candy/Wafer.png',
        level: '1',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 81,
        createdAt: '2019-09-28T06:31:10.000Z',
        updatedAt: '2019-09-28T06:33:25.000Z'
    },
    {
        name: 'c82',
        word: '{"en":"Hotdog","vi":"Bánh mì kẹp xúc xích"}',
        path: 'candy/Hotdog.png',
        level: '2',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 82,
        createdAt: '2019-09-28T06:34:14.000Z',
        updatedAt: '2019-09-28T06:34:14.000Z'
    },
    {
        name: 'c83',
        word: '{"en":"Mochi","vi":"Bánh mochi"}',
        path: 'candy/Mochi.png',
        level: '3',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 83,
        createdAt: '2019-09-28T06:34:38.000Z',
        updatedAt: '2019-09-28T06:34:38.000Z'
    },
    {
        name: 'c84',
        word: '{"en":"Jelly fruit slices","vi":""}',
        path: 'candy/Jelly_fruit_slices.png',
        level: '4',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 84,
        createdAt: '2019-09-28T06:35:09.000Z',
        updatedAt: '2019-09-28T06:35:09.000Z'
    },
    {
        name: 'c85',
        word: '{"en":"Bite","vi":"Cắn"}',
        path: 'candy/Bite.png',
        level: '5',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 85,
        createdAt: '2019-09-28T06:36:00.000Z',
        updatedAt: '2019-09-28T06:36:00.000Z'
    },
    {
        name: 'c86',
        word: '{"en":"Grapes dry","vi":"Nho khô"}',
        path: 'candy/Grapes_dry.png',
        level: '6',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 86,
        createdAt: '2019-09-28T06:37:17.000Z',
        updatedAt: '2019-09-28T06:37:17.000Z'
    },
    {
        name: 'c87',
        word: '{"en":"Peanut candy","vi":"Kẹo lạc"}',
        path: 'candy/Peanut_candy.png',
        level: '7',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 87,
        createdAt: '2019-09-28T06:37:58.000Z',
        updatedAt: '2019-09-28T06:37:58.000Z'
    },
    {
        name: 'c88',
        word: '{"en":"Candy jar","vi":"Bình kẹo"}',
        path: 'candy/Candy_jar.png',
        level: '8',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 88,
        createdAt: '2019-09-28T06:38:24.000Z',
        updatedAt: '2019-09-28T06:38:24.000Z'
    },
    {
        name: 'c89',
        word: '{"en":"Gumdrops","vi":"Kẹo gôm dẻo"}',
        path: 'candy/Gumdrops.png',
        level: '9',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 89,
        createdAt: '2019-09-28T06:38:48.000Z',
        updatedAt: '2019-09-28T06:38:48.000Z'
    },
    {
        name: 'c90',
        word: '{"en":"Peanut nougat","vi":""}',
        path: 'candy/Peanut_nougat.png',
        level: '10',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 90,
        createdAt: '2019-09-28T06:40:27.000Z',
        updatedAt: '2019-09-28T06:40:27.000Z'
    },
    {
        name: 'c91',
        word: '{"en":"Chewing gum","vi":"Kẹo cao su"}',
        path: 'candy/Chewing_gum.png',
        level: '11',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 91,
        createdAt: '2019-09-28T06:41:51.000Z',
        updatedAt: '2019-09-28T06:41:51.000Z'
    },
    {
        name: 'c92',
        word: '{"en":"Glutinous rice balls","vi":"Bánh trôi"}',
        path: 'candy/Glutinous_rice_balls.png',
        level: '12',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 92,
        createdAt: '2019-09-28T06:43:18.000Z',
        updatedAt: '2019-09-28T06:43:18.000Z'
    },
    {
        name: 'c93',
        word: '{"en":"Rainbow lollipop","vi":"Kẹo mút cầu vồng"}',
        path: 'candy/Rainbow_lollipop.png',
        level: '13',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 93,
        createdAt: '2019-09-28T06:43:57.000Z',
        updatedAt: '2019-09-28T06:43:57.000Z'
    },
    {
        name: 'c94',
        word: '{"en":"Watermelon popsicle","vi":"Kem dưa hấu"}',
        path: 'candy/Watermelon_popsicle.png',
        level: '14',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 94,
        createdAt: '2019-09-28T06:44:29.000Z',
        updatedAt: '2019-09-28T06:44:29.000Z'
    },
    {
        name: 'c95',
        word: '{"en":"Apple Pies","vi":"Bánh táo"}',
        path: 'candy/Apple_Pies.png',
        level: '15',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 95,
        createdAt: '2019-09-28T06:44:51.000Z',
        updatedAt: '2019-09-28T06:44:51.000Z'
    },
    {
        name: 'c96',
        word: '{"en":"Strawberry jam","vi":"Mứt dâu"}',
        path: 'candy/Strawberry_jam.png',
        level: '16',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 96,
        createdAt: '2019-09-28T06:45:19.000Z',
        updatedAt: '2019-09-28T06:45:19.000Z'
    },
    {
        name: 'c97',
        word: '{"en":"Lemon popsicle","vi":"Kem chanh"}',
        path: 'candy/Lemon_popsicle.png',
        level: '17',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 97,
        createdAt: '2019-09-28T06:45:44.000Z',
        updatedAt: '2019-09-28T06:45:44.000Z'
    },
    {
        name: 'c98',
        word: '{"en":"Lick","vi":"Liếm"}',
        path: 'candy/Lick.png',
        level: '18',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 98,
        createdAt: '2019-09-28T06:46:04.000Z',
        updatedAt: '2019-09-28T06:46:04.000Z'
    },
    {
        name: 'c99',
        word: '{"en":"Cream horn","vi":"Bánh kem sừng"}',
        path: 'candy/Cream_horn.png',
        level: '19',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 99,
        createdAt: '2019-09-28T06:46:23.000Z',
        updatedAt: '2019-09-28T06:46:23.000Z'
    },
    {
        name: 'c100',
        word: '{"en":"Watermelon lollipop","vi":"Kẹo mút dưa hấu"}',
        path: 'candy/Watermelon_lollipop.png',
        level: '20',
        map: '2',
        topic: 'SWEET',
        status: 'ACTIVE',
        id: 100,
        createdAt: '2019-09-28T06:46:44.000Z',
        updatedAt: '2019-09-28T06:46:44.000Z'
    },
    {
        name: 'e1',
        word: '{"en":"Tree","vi":"Cây"}',
        path: 'environment/Tree.png',
        level: '1',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 101,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'e2',
        word: '{"en":"Leaf","vi":"Lá"}',
        path: 'environment/Leaf.png',
        level: '2',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 102,
        createdAt: '2019-09-28T06:54:12.000Z',
        updatedAt: '2019-09-28T06:54:12.000Z'
    },
    {
        name: 'e3',
        word: '{"en":"Flower","vi":"Hoa"}',
        path: 'environment/Flower.png',
        level: '3',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 103,
        createdAt: '2019-09-28T06:54:37.000Z',
        updatedAt: '2019-09-28T07:24:02.000Z'
    },
    {
        name: 'e4',
        word: '{"en":"Axe","vi":"Rìu"}',
        path: 'environment/Axe.png',
        level: '4',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 104,
        createdAt: '2019-09-28T06:55:28.000Z',
        updatedAt: '2019-09-28T06:55:28.000Z'
    },
    {
        name: 'e5',
        word: '{"en":"Chainsaw","vi":"Máy cưa"}',
        path: 'environment/Chainsaw.png',
        level: '5',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 105,
        createdAt: '2019-09-28T06:55:52.000Z',
        updatedAt: '2019-10-07T08:46:00.000Z'
    },
    {
        name: 'e6',
        word: '{"en":"Recycle bin","vi":"Thùng rác"}',
        path: 'environment/Recycle_bin.png',
        level: '6',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 106,
        createdAt: '2019-09-28T06:56:15.000Z',
        updatedAt: '2019-09-28T06:56:15.000Z'
    },
    {
        name: 'e7',
        word: '{"en":"Shovel","vi":"Cái xẻng"}',
        path: 'environment/Shovel.png',
        level: '7',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 107,
        createdAt: '2019-09-28T06:56:49.000Z',
        updatedAt: '2019-09-28T06:56:49.000Z'
    },
    {
        name: 'e8',
        word: '{"en":"Rake","vi":"Cái_cào"}',
        path: 'environment/Rake.png',
        level: '8',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 108,
        createdAt: '2019-09-28T06:58:15.000Z',
        updatedAt: '2019-09-28T06:58:15.000Z'
    },
    {
        name: 'e9',
        word: '{"en":"Wheel_barrow","vi":"Xe_cút_kít"}',
        path: 'environment/Wheel_barrow.png',
        level: '9',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 109,
        createdAt: '2019-09-28T07:22:19.000Z',
        updatedAt: '2019-09-28T07:23:55.000Z'
    },
    {
        name: 'e10',
        word: '{"en":"Lawnmover","vi":"Máy cắt cỏ"}',
        path: 'environment/Lawnmover.png',
        level: '10',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 110,
        createdAt: '2019-09-28T07:23:01.000Z',
        updatedAt: '2019-09-28T07:23:49.000Z'
    },
    {
        name: 'e11',
        word: '{"en":"Watering can","vi":"Bình tưới nước"}',
        path: 'environment/Watering_can.png',
        level: '11',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 111,
        createdAt: '2019-09-28T07:23:24.000Z',
        updatedAt: '2019-09-28T07:23:24.000Z'
    },
    {
        name: 'e12',
        word: '{"en":"Seedling","vi":"Cây giống"}',
        path: 'environment/Seedling.png',
        level: '12',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 112,
        createdAt: '2019-09-28T07:24:41.000Z',
        updatedAt: '2019-09-28T07:24:41.000Z'
    },
    {
        name: 'e13',
        word: '{"en":"Seed","vi":"Hạt giống"}',
        path: 'environment/Seed.png',
        level: '13',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 113,
        createdAt: '2019-09-28T07:25:12.000Z',
        updatedAt: '2019-09-28T07:25:12.000Z'
    },
    {
        name: 'e14',
        word: '{"en":"Fertilizer","vi":"Phân bón"}',
        path: 'environment/Fertilizer.png',
        level: '14',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 114,
        createdAt: '2019-09-28T07:25:31.000Z',
        updatedAt: '2019-09-28T07:25:31.000Z'
    },
    {
        name: 'e15',
        word: '{"en":"Soil","vi":"Đất"}',
        path: 'environment/Soil.png',
        level: '15',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 115,
        createdAt: '2019-09-28T07:25:52.000Z',
        updatedAt: '2019-09-28T07:25:52.000Z'
    },
    {
        name: 'e16',
        word: '{"en":"Gloves","vi":"Găng tay"}',
        path: 'environment/Gloves.png',
        level: '16',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 116,
        createdAt: '2019-09-28T07:26:17.000Z',
        updatedAt: '2019-09-28T07:26:17.000Z'
    },
    {
        name: 'e17',
        word: '{"en":"Christmas tree","vi":"Cây giáng sinh"}',
        path: 'environment/Christmas_tree.png',
        level: '17',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 117,
        createdAt: '2019-09-28T07:26:46.000Z',
        updatedAt: '2019-10-07T08:46:53.000Z'
    },
    {
        name: 'e18',
        word: '{"en":"Bamboo","vi":"Cây tre"}',
        path: 'environment/Bamboo.png',
        level: '18',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 118,
        createdAt: '2019-09-28T07:27:11.000Z',
        updatedAt: '2019-09-28T07:27:11.000Z'
    },
    {
        name: 'e19',
        word: '{"en":"Forest","vi":"Rừng"}',
        path: 'environment/Forest.png',
        level: '19',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 119,
        createdAt: '2019-09-28T07:27:33.000Z',
        updatedAt: '2019-09-28T07:27:33.000Z'
    },
    {
        name: 'e20',
        word: '{"en":"Bush","vi":"Bụi cây"}',
        path: 'environment/Bush.png',
        level: '20',
        map: '1',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 120,
        createdAt: '2019-09-28T07:27:56.000Z',
        updatedAt: '2019-09-28T07:28:06.000Z'
    },
    {
        name: 'e21',
        word: '{"en":"Grass","vi":"Cỏ"}',
        path: 'environment/Grass.png',
        level: '1',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 121,
        createdAt: '2019-09-28T07:28:34.000Z',
        updatedAt: '2019-09-28T07:28:34.000Z'
    },
    {
        name: 'e22',
        word: '{"en":"Beach","vi":"Bãi biển"}',
        path: 'environment/Beach.jpg',
        level: '2',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 122,
        createdAt: '2019-09-28T07:29:04.000Z',
        updatedAt: '2019-09-28T07:29:04.000Z'
    },
    {
        name: 'e23',
        word: '{"en":"Broom","vi":"Cái chổi"}',
        path: 'environment/Broom.png',
        level: '3',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 123,
        createdAt: '2019-09-28T07:29:51.000Z',
        updatedAt: '2019-09-28T07:29:51.000Z'
    },
    {
        name: 'e24',
        word: '{"en":"Garbage","vi":"Rác thải"}',
        path: 'environment/Garbage.png',
        level: '4',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 124,
        createdAt: '2019-09-28T07:30:30.000Z',
        updatedAt: '2019-09-28T07:30:30.000Z'
    },
    {
        name: 'e25',
        word: '{"en":"Coconut tree","vi":"Cây dừa"}',
        path: 'environment/Coconut_tree.png',
        level: '5',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 125,
        createdAt: '2019-09-28T07:30:55.000Z',
        updatedAt: '2019-09-28T07:30:55.000Z'
    },
    {
        name: 'e26',
        word: '{"en":"Willow ","vi":"Cây liễu"}',
        path: 'environment/Willow.png',
        level: '6',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 126,
        createdAt: '2019-09-28T07:31:15.000Z',
        updatedAt: '2019-09-28T07:31:15.000Z'
    },
    {
        name: 'e27',
        word: '{"en":"Corn tree","vi":"Cây ngô"}',
        path: 'environment/Corn_tree.png',
        level: '7',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 127,
        createdAt: '2019-09-28T07:31:37.000Z',
        updatedAt: '2019-09-28T07:31:37.000Z'
    },
    {
        name: 'e28',
        word: '{"en":"Cactus","vi":"Xương rồng"}',
        path: 'environment/Cactus.png',
        level: '8',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 128,
        createdAt: '2019-09-28T07:31:58.000Z',
        updatedAt: '2019-10-07T08:45:45.000Z'
    },
    {
        name: 'e29',
        word: '{"en":"Lotus","vi":"Hoa sen"}',
        path: 'environment/Lotus.png',
        level: '9',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 129,
        createdAt: '2019-09-28T07:32:20.000Z',
        updatedAt: '2019-10-07T08:45:35.000Z'
    },
    {
        name: 'e30',
        word: '{"en":"Mushroom ","vi":"Cây nấm"}',
        path: 'environment/Mushroom.png',
        level: '10',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 130,
        createdAt: '2019-09-28T07:32:39.000Z',
        updatedAt: '2019-09-28T07:32:39.000Z'
    },
    {
        name: 'e31',
        word: '{"en":"Sugar cane","vi":"Cây mía"}',
        path: 'environment/Sugar_cane.png',
        level: '11',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 131,
        createdAt: '2019-09-28T07:32:58.000Z',
        updatedAt: '2019-09-28T07:32:58.000Z'
    },
    {
        name: 'e32',
        word: '{"en":"Peach tree","vi":"Cây anh đào"}',
        path: 'environment/Peach_tree.png',
        level: '12',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 132,
        createdAt: '2019-09-28T07:33:25.000Z',
        updatedAt: '2019-09-28T07:33:25.000Z'
    },
    {
        name: 'e33',
        word: '{"en":"Bonsai","vi":"Cây cảnh"}',
        path: 'environment/Bonsai.png',
        level: '13',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 133,
        createdAt: '2019-09-28T07:33:45.000Z',
        updatedAt: '2019-09-28T07:33:45.000Z'
    },
    {
        name: 'e34',
        word: '{"en":"Pansy","vi":"Tử La Lan"}',
        path: 'environment/Pansy.png',
        level: '14',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 134,
        createdAt: '2019-09-28T07:34:12.000Z',
        updatedAt: '2019-09-28T07:34:12.000Z'
    },
    {
        name: 'e35',
        word: '{"en":"Frangipani","vi":"Hoa đại"}',
        path: 'environment/Frangipani.png',
        level: '15',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 135,
        createdAt: '2019-09-28T07:34:39.000Z',
        updatedAt: '2019-09-28T07:34:39.000Z'
    },
    {
        name: 'e36',
        word: '{"en":"Aloe","vi":"Lô hội"}',
        path: 'environment/Aloe.png',
        level: '16',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 136,
        createdAt: '2019-09-28T07:35:10.000Z',
        updatedAt: '2019-09-28T07:35:10.000Z'
    },
    {
        name: 'e37',
        word: '{"en":"Stump","vi":"Gốc cây"}',
        path: 'environment/Stump.png',
        level: '17',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 137,
        createdAt: '2019-09-28T07:35:32.000Z',
        updatedAt: '2019-09-28T07:35:32.000Z'
    },
    {
        name: 'e38',
        word: '{"en":"Anemone","vi":"Hải quỳ"}',
        path: 'environment/Anemone.png',
        level: '18',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 138,
        createdAt: '2019-09-28T07:35:58.000Z',
        updatedAt: '2019-09-28T07:35:58.000Z'
    },
    {
        name: 'E39',
        word: '{"en":"Bougainvillea","vi":"Hoa giấy"}',
        path: 'environment/Bougainvillea.png',
        level: '19',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 139,
        createdAt: '2019-09-28T07:39:04.000Z',
        updatedAt: '2019-09-28T07:39:04.000Z'
    },
    {
        name: 'E40',
        word: '{"en":"Tulip","vi":"Hoa Tulip"}',
        path: 'environment/Tulip.png',
        level: '20',
        map: '2',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 140,
        createdAt: '2019-09-28T07:39:26.000Z',
        updatedAt: '2019-10-07T08:47:37.000Z'
    },
    {
        name: 'E41',
        word: '{"en":"Fern","vi":"Cây dương xỉ"}',
        path: 'environment/Fern.png',
        level: '1',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 141,
        createdAt: '2019-09-28T07:40:10.000Z',
        updatedAt: '2019-09-28T07:40:10.000Z'
    },
    {
        name: 'E42',
        word: '{"en":"Pot","vi":"Chậu cây"}',
        path: 'environment/Pot.png',
        level: '2',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 142,
        createdAt: '2019-09-28T07:40:36.000Z',
        updatedAt: '2019-10-18T16:01:23.000Z'
    },
    {
        name: 'E43',
        word: '{"en":"Trunk","vi":"Thân cây"}',
        path: 'environment/Trunk.png',
        level: '3',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 143,
        createdAt: '2019-09-28T07:41:06.000Z',
        updatedAt: '2019-09-28T07:41:06.000Z'
    },
    {
        name: 'E44',
        word: '{"en":"Peony","vi":"Mẫu đơn"}',
        path: 'environment/Peony.png',
        level: '4',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 144,
        createdAt: '2019-09-28T07:43:27.000Z',
        updatedAt: '2019-09-28T07:43:27.000Z'
    },
    {
        name: 'E45',
        word: '{"en":"Lily","vi":"Hoa Ly"}',
        path: 'environment/Lily.png',
        level: '5',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 145,
        createdAt: '2019-09-28T07:43:52.000Z',
        updatedAt: '2019-09-28T07:43:52.000Z'
    },
    {
        name: 'E46',
        word: '{"en":"Lilac","vi":"Tử đinh hương"}',
        path: 'environment/Lilac.png',
        level: '6',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 146,
        createdAt: '2019-09-28T07:44:22.000Z',
        updatedAt: '2019-09-28T07:44:22.000Z'
    },
    {
        name: 'E47',
        word: '{"en":"Sunflower ","vi":"Hoa hướng dương"}',
        path: 'environment/Sunflower.png',
        level: '7',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 147,
        createdAt: '2019-09-28T07:44:56.000Z',
        updatedAt: '2019-10-14T11:17:17.000Z'
    },
    {
        name: 'E48',
        word: '{"en":"Gladiolus","vi":"Cây lai ơn"}',
        path: 'environment/Gladiolus.png',
        level: '8',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 148,
        createdAt: '2019-09-28T07:48:02.000Z',
        updatedAt: '2019-09-28T07:48:02.000Z'
    },
    {
        name: 'E49',
        word: '{"en":"Gerbera","vi":"Hoa đồng tiền"}',
        path: 'environment/Gerbera.png',
        level: '9',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 149,
        createdAt: '2019-09-28T07:48:25.000Z',
        updatedAt: '2019-09-28T07:48:25.000Z'
    },
    {
        name: 'E50',
        word: '{"en":"Hydrangea","vi":"Cẩm tú cầu"}',
        path: 'environment/Hydrangea.png',
        level: '10',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 150,
        createdAt: '2019-09-28T07:48:45.000Z',
        updatedAt: '2019-09-28T07:48:45.000Z'
    },
    {
        name: 'E51',
        word: '{"en":"Dahlia","vi":"Thược dược"}',
        path: 'environment/Dahlia.png',
        level: '11',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 151,
        createdAt: '2019-09-28T07:49:09.000Z',
        updatedAt: '2019-09-28T07:49:09.000Z'
    },
    {
        name: 'E52',
        word: '{"en":"Marigold","vi":"Cúc vạn thọ"}',
        path: 'environment/Marigold.png',
        level: '12',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 152,
        createdAt: '2019-09-28T07:49:41.000Z',
        updatedAt: '2019-09-28T07:49:41.000Z'
    },
    {
        name: 'E53',
        word: '{"en":"Hibiscus","vi":"Hoa dâm bụt"}',
        path: 'environment/Hibiscus.png',
        level: '13',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 153,
        createdAt: '2019-09-28T07:50:08.000Z',
        updatedAt: '2019-09-28T07:50:08.000Z'
    },
    {
        name: 'E54',
        word: '{"en":"Dig","vi":"Đào"}',
        path: 'environment/Dig.png',
        level: '14',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 154,
        createdAt: '2019-09-28T07:50:32.000Z',
        updatedAt: '2019-09-28T07:50:32.000Z'
    },
    {
        name: 'E55',
        word: '{"en":"Apricot blossom","vi":"Hoa mai"}',
        path: 'environment/Apricot_blossom.png',
        level: '15',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 155,
        createdAt: '2019-09-28T07:50:56.000Z',
        updatedAt: '2019-09-28T07:50:56.000Z'
    },
    {
        name: 'E56',
        word: '{"en":"Grow","vi":"Trồng"}',
        path: 'environment/Grow.png',
        level: '16',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 156,
        createdAt: '2019-09-28T07:51:20.000Z',
        updatedAt: '2019-09-28T07:51:20.000Z'
    },
    {
        name: 'E57',
        word: '{"en":"Dandelion","vi":"Bồ công anh"}',
        path: 'environment/Dandelion.png',
        level: '17',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 157,
        createdAt: '2019-09-28T07:51:42.000Z',
        updatedAt: '2019-09-28T07:51:42.000Z'
    },
    {
        name: 'E58',
        word: '{"en":"Daffodil","vi":"Hoa Thủy tiên"}',
        path: 'environment/Daffodil.png',
        level: '18',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 158,
        createdAt: '2019-09-28T07:52:01.000Z',
        updatedAt: '2019-09-28T07:52:01.000Z'
    },
    {
        name: 'E59',
        word: '{"en":"Poinsettia","vi":"Hoa trạng nguyên"}',
        path: 'environment/Poinsettia.png',
        level: '19',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 159,
        createdAt: '2019-09-28T07:52:22.000Z',
        updatedAt: '2019-09-28T07:52:22.000Z'
    },
    {
        name: 'E60',
        word: '{"en":"Azalea","vi":"Đỗ quyên"}',
        path: 'environment/Azalea.png',
        level: '20',
        map: '3',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 160,
        createdAt: '2019-09-28T07:52:41.000Z',
        updatedAt: '2019-09-28T07:52:41.000Z'
    },
    {
        name: 'E61',
        word: '{"en":"Rose","vi":"Hoa hồng"}',
        path: 'environment/Rose.png',
        level: '1',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 161,
        createdAt: '2019-09-28T07:53:05.000Z',
        updatedAt: '2019-09-28T07:53:05.000Z'
    },
    {
        name: 'E62',
        word: '{"en":"Iris","vi":"Hoa Diên vĩ"}',
        path: 'environment/Iris.png',
        level: '2',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 162,
        createdAt: '2019-09-28T07:53:26.000Z',
        updatedAt: '2019-09-28T07:53:26.000Z'
    },
    {
        name: 'E63',
        word: '{"en":"Wheat","vi":"Lúa mì"}',
        path: 'environment/Wheat.png',
        level: '3',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 163,
        createdAt: '2019-09-28T07:54:22.000Z',
        updatedAt: '2019-09-28T07:54:22.000Z'
    },
    {
        name: 'E64',
        word: '{"en":"Cherry blossom","vi":"Hoa đào"}',
        path: 'environment/Cherry_blossom.png',
        level: '4',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 164,
        createdAt: '2019-09-28T07:54:49.000Z',
        updatedAt: '2019-09-28T07:54:49.000Z'
    },
    {
        name: 'E65',
        word: '{"en":"Camellia","vi":"Hoa Trà My"}',
        path: 'environment/Camellia.png',
        level: '5',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 165,
        createdAt: '2019-09-28T07:55:14.000Z',
        updatedAt: '2019-09-28T07:55:14.000Z'
    },
    {
        name: 'E66',
        word: '{"en":"Epihyllum","vi":"Hoa quỳnh"}',
        path: 'environment/Epihyllum.png',
        level: '6',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 166,
        createdAt: '2019-09-28T07:55:37.000Z',
        updatedAt: '2019-09-28T07:55:37.000Z'
    },
    {
        name: 'E67',
        word: '{"en":"Arum Lily","vi":"Hoa Thủy Vu"}',
        path: 'environment/Arum_Lily.png',
        level: '7',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 167,
        createdAt: '2019-09-28T07:55:57.000Z',
        updatedAt: '2019-09-28T07:55:57.000Z'
    },
    {
        name: 'E68',
        word: '{"en":"Jasmine","vi":"Hoa nhài"}',
        path: 'environment/Jasmine.png',
        level: '8',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 168,
        createdAt: '2019-09-28T07:56:14.000Z',
        updatedAt: '2019-09-28T07:56:14.000Z'
    },
    {
        name: 'E69',
        word: '{"en":"Lagerstroemia","vi":"Hoa bằng lăng"}',
        path: 'environment/Lagerstroemia.png',
        level: '9',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 169,
        createdAt: '2019-09-28T07:56:35.000Z',
        updatedAt: '2019-09-28T07:56:35.000Z'
    },
    {
        name: 'E70',
        word: '{"en":"Orange tree","vi":"Cây cam"}',
        path: 'environment/Orange_tree.png',
        level: '10',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 170,
        createdAt: '2019-09-28T07:57:01.000Z',
        updatedAt: '2019-09-28T07:57:01.000Z'
    },
    {
        name: 'E71',
        word: '{"en":"Strawberry tree","vi":"Cây dâu tây"}',
        path: 'environment/Strawberry_tree.png',
        level: '11',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 171,
        createdAt: '2019-09-28T07:57:27.000Z',
        updatedAt: '2019-09-28T07:57:27.000Z'
    },
    {
        name: 'E72',
        word: '{"en":"Lavender","vi":"Hoa oải hương"}',
        path: 'environment/Lavender.png',
        level: '12',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 172,
        createdAt: '2019-09-28T07:57:48.000Z',
        updatedAt: '2019-09-28T07:57:48.000Z'
    },
    {
        name: 'E73',
        word: '{"en":"Petunia","vi":"Cây dạ yên thảo"}',
        path: 'environment/Petunia.png',
        level: '13',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 173,
        createdAt: '2019-09-28T07:58:10.000Z',
        updatedAt: '2019-09-28T07:58:10.000Z'
    },
    {
        name: 'E74',
        word: '{"en":"Hippeastrum","vi":"Lan Huệ"}',
        path: 'environment/Hippeastrum.png',
        level: '14',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 174,
        createdAt: '2019-09-28T07:58:41.000Z',
        updatedAt: '2019-10-07T08:48:35.000Z'
    },
    {
        name: 'E75',
        word: '{"en":"Daisy","vi":"Hoa xuyến chi"}',
        path: 'environment/Daisy.png',
        level: '15',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 175,
        createdAt: '2019-09-28T07:59:00.000Z',
        updatedAt: '2019-09-28T07:59:00.000Z'
    },
    {
        name: 'E76',
        word: '{"en":"Asters","vi":"Cây thúy cúc"}',
        path: 'environment/Asters.png',
        level: '16',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 176,
        createdAt: '2019-09-28T07:59:24.000Z',
        updatedAt: '2019-09-28T07:59:24.000Z'
    },
    {
        name: 'E77',
        word: '{"en":"Carnation","vi":"Cẩm chướng"}',
        path: 'environment/Carnation.png',
        level: '17',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 177,
        createdAt: '2019-09-28T07:59:49.000Z',
        updatedAt: '2019-09-28T07:59:49.000Z'
    },
    {
        name: 'E78',
        word: '{"en":"Nunephar","vi":"Hoa súng"}',
        path: 'environment/Nunephar.png',
        level: '18',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 178,
        createdAt: '2019-09-28T08:00:09.000Z',
        updatedAt: '2019-10-07T08:49:01.000Z'
    },
    {
        name: 'E79',
        word: '{"en":"Pile up","vi":"Vun"}',
        path: 'environment/Pile_Up.png',
        level: '19',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 179,
        createdAt: '2019-09-28T08:00:37.000Z',
        updatedAt: '2019-09-28T08:00:37.000Z'
    },
    {
        name: 'E80',
        word: '{"en":"Tuberose","vi":"Hoa huệ"}',
        path: 'environment/Tuberose.png',
        level: '20',
        map: '4',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 180,
        createdAt: '2019-09-28T08:00:58.000Z',
        updatedAt: '2019-09-28T08:00:58.000Z'
    },
    {
        name: 'E81',
        word: '{"en":"Reed","vi":"Cây lau (sậy)"}',
        path: 'environment/Reed.png',
        level: '1',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 181,
        createdAt: '2019-09-28T08:03:21.000Z',
        updatedAt: '2019-09-28T08:03:21.000Z'
    },
    {
        name: 'E82',
        word: '{"en":"Wood","vi":"Gỗ"}',
        path: 'environment/Wood.png',
        level: '2',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 182,
        createdAt: '2019-09-28T08:03:45.000Z',
        updatedAt: '2019-09-28T08:03:45.000Z'
    },
    {
        name: 'E83',
        word: '{"en":"Orchid","vi":"Hoa lan"}',
        path: 'environment/Orchid.png',
        level: '3',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 183,
        createdAt: '2019-09-28T08:04:29.000Z',
        updatedAt: '2019-09-28T08:04:29.000Z'
    },
    {
        name: 'E84',
        word: '{"en":"Lantana","vi":"Hoa trâm ổi"}',
        path: 'environment/Lantana.png',
        level: '4',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 184,
        createdAt: '2019-09-28T08:04:54.000Z',
        updatedAt: '2019-10-07T08:49:33.000Z'
    },
    {
        name: 'E85',
        word: '{"en":"Portulaca","vi":"Hoa mười giờ"}',
        path: 'environment/Portulaca.png',
        level: '5',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 185,
        createdAt: '2019-09-28T08:05:33.000Z',
        updatedAt: '2019-09-28T08:05:33.000Z'
    },
    {
        name: 'E86',
        word: '{"en":"Dump","vi":"Đổ"}',
        path: 'environment/Dump.png',
        level: '6',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 186,
        createdAt: '2019-09-28T08:05:59.000Z',
        updatedAt: '2019-09-28T08:05:59.000Z'
    },
    {
        name: 'E87',
        word: '{"en":"Throw","vi":"Ném, vứt"}',
        path: 'environment/Throw.png',
        level: '7',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 187,
        createdAt: '2019-09-28T08:06:27.000Z',
        updatedAt: '2019-09-28T08:06:27.000Z'
    },
    {
        name: 'E88',
        word: '{"en":"Magnolia","vi":"Hoa mộc lan"}',
        path: 'environment/Magnolia.png',
        level: '8',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 188,
        createdAt: '2019-09-28T08:06:45.000Z',
        updatedAt: '2019-09-28T08:06:45.000Z'
    },
    {
        name: 'E89',
        word: '{"en":"Push","vi":"Đẩy"}',
        path: 'environment/Push.png',
        level: '9',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 189,
        createdAt: '2019-09-28T08:07:05.000Z',
        updatedAt: '2019-09-28T08:07:05.000Z'
    },
    {
        name: 'E90',
        word: '{"en":"Anthurium","vi":"Hồng môn"}',
        path: 'environment/Anthurium.png',
        level: '10',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 190,
        createdAt: '2019-09-28T08:07:31.000Z',
        updatedAt: '2019-09-28T08:07:31.000Z'
    },
    {
        name: 'E91',
        word: '{"en":"Mimosa pudica","vi":"Cây trinh nữ"}',
        path: 'environment/Mimosa_pudica.png',
        level: '11',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 191,
        createdAt: '2019-09-28T08:07:58.000Z',
        updatedAt: '2019-10-07T08:50:00.000Z'
    },
    {
        name: 'E92',
        word: '{"en":"Chrysanthemum","vi":"Hoa cúc"}',
        path: 'environment/Chrysanthemum.png',
        level: '12',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 192,
        createdAt: '2019-09-28T08:08:33.000Z',
        updatedAt: '2019-09-28T08:08:33.000Z'
    },
    {
        name: 'E93',
        word: '{"en":"Pull","vi":"Kéo"}',
        path: 'environment/Pull.png',
        level: '13',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 193,
        createdAt: '2019-09-28T08:09:29.000Z',
        updatedAt: '2019-09-28T08:09:29.000Z'
    },
    {
        name: 'E94',
        word: '{"en":"Bauhinia","vi":"Hoa ban"}',
        path: 'environment/Bauhinia.png',
        level: '14',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 193,
        createdAt: '2019-09-28T08:09:29.000Z',
        updatedAt: '2019-09-28T08:09:29.000Z'
    },
    {
        name: 'E95',
        word: '{"en":"Flamboyant","vi":"Phượng vĩ"}',
        path: 'environment/Flamboyant.png',
        level: '15',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 194,
        createdAt: '2019-09-28T08:09:50.000Z',
        updatedAt: '2019-09-28T08:09:50.000Z'
    },
    {
        name: 'E96',
        word: '{"en":"Wisteria","vi":"Hoa Tử đằng"}',
        path: 'environment/Wisteria.png',
        level: '16',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 195,
        createdAt: '2019-09-28T08:10:16.000Z',
        updatedAt: '2019-09-28T08:10:16.000Z'
    },
    {
        name: 'E97',
        word: '{"en":"Banana tree","vi":"Cây chuối"}',
        path: 'environment/Banana_tree.png',
        level: '17',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 196,
        createdAt: '2019-09-28T08:11:06.000Z',
        updatedAt: '2019-09-28T08:11:06.000Z'
    },
    {
        name: 'E98',
        word: '{"en":"For get me not","vi":"Hoa lưu ly"}',
        path: 'environment/For_get_me_not.png',
        level: '18',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 197,
        createdAt: '2019-09-28T08:11:26.000Z',
        updatedAt: '2019-09-28T08:11:26.000Z'
    },
    {
        name: 'E99',
        word: '{"en":"Daphne","vi":"Hoa Thụy hương"}',
        path: 'environment/Daphne.png',
        level: '19',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 198,
        createdAt: '2019-09-28T08:11:55.000Z',
        updatedAt: '2019-09-28T08:11:55.000Z'
    },
    {
        name: 'E100',
        word: '{"en":"Zinnia","vi":"Hoa Bách nhật"}',
        path: 'environment/Zinnia.png',
        level: '20',
        map: '5',
        topic: 'ENVIRONMENT',
        status: 'ACTIVE',
        id: 199,
        createdAt: '2019-09-28T08:12:20.000Z',
        updatedAt: '2019-09-28T08:12:20.000Z'
    },
    {
        name: 'D1',
        word: '{"en":"Dentist","vi":"Nha sĩ"}',
        path: 'dentist/Dentist.png',
        level: '1',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 201,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D2',
        word: '{"en":"Tooth","vi":"Răng"}',
        path: 'dentist/Tooth.png',
        level: '2',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 202,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D3',
        word: '{"en":"Toothpaste","vi":"Kem đánh răng"}',
        path: 'dentist/Toothpaste.png',
        level: '3',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 203,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D4',
        word: '{"en":"Tooth Extraction","vi":"Nhổ răng"}',
        path: 'dentist/Tooth_Extraction.png',
        level: '4',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 204,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D5',
        word: '{"en":"Dental Handpieces","vi":"Tay khoan nha khoa"}',
        path: 'dentist/Dental_Handpieces.png',
        level: '5',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 205,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D6',
        word: '{"en":"Nail Scissors","vi":"Bấm móng tay"}',
        path: 'dentist/Nail_Scissors.png',
        level: '6',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 206,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D7',
        word: '{"en":"Nail File","vi":"Rũa móng tay"}',
        path: 'dentist/Nail_File.png',
        level: '7',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 207,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D8',
        word: '{"en":"Wisdom Tooth","vi":"Răng khôn"}',
        path: 'dentist/Wisdom_Tooth.jpg',
        level: '8',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 208,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D9',
        word: '{"en":"Mouth","vi":"Miệng"}',
        path: 'dentist/Mouth.png',
        level: '9',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 209,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D10',
        word: '{"en":"Baby Tooth","vi":"Răng sữa"}',
        path: 'dentist/Baby_Tooth.png',
        level: '10',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 210,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D11',
        word: '{"en":"Gum","vi":"Lợi (Nướu)"}',
        path: 'dentist/Gum.png',
        level: '11',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 211,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D12',
        word: '{"en":"Permanent Tooth","vi":"Răng vĩnh viển"}',
        path: 'dentist/Permanent_Tooth.png',
        level: '12',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 212,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D13',
        word: '{"en":"Incisor","vi":"Răng cửa"}',
        path: 'dentist/Incisor.png',
        level: '13',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 213,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D14',
        word: '{"en":"False Tooth","vi":"Răng giả"}',
        path: 'dentist/False_Tooth.png',
        level: '14',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 214,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D15',
        word: '{"en":"Toothbrush","vi":"Bàn chải đánh răng"}',
        path: 'dentist/Toothbrush.png',
        level: '15',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 215,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D16',
        word: '{"en":"Toothache","vi":"Đau răng"}',
        path: 'dentist/Toothache.png',
        level: '16',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 216,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D17',
        word: '{"en":"Canker Sores","vi":"Nhiệt miệng"}',
        path: 'dentist/Canker_Sores.png',
        level: '17',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 217,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D18',
        word: '{"en":"Crowding Teeth","vi":"Hàm răng khấp khiểng"}',
        path: 'dentist/Crowding_Teeth.png',
        level: '18',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 218,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D19',
        word: '{"en":"Crooked Teeth","vi":"Răng khểnh"}',
        path: 'dentist/Crooked_Teeth.png',
        level: '19',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 219,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D20',
        word: '{"en":"Wash The Hands","vi":"Rửa tay"}',
        path: 'dentist/Wash_The_Hands.png',
        level: '20',
        map: '5',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 220,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D21',
        word: '{"en":"Toothpick","vi":"Tăm xỉa răng"}',
        path: 'dentist/Toothpick.png',
        level: '1',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 221,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D22',
        word: '{"en":"Floss","vi":"Chỉ nha khoa"}',
        path: 'dentist/Floss.png',
        level: '2',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 222,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D23',
        word: '{"en":"Mirror","vi":"Gương"}',
        path: 'dentist/Mirror.png',
        level: '3',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 223,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D24',
        word: '{"en":"Braces","vi":"Niềng răng"}',
        path: 'dentist/Braces.png',
        level: '4',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 224,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D25',
        word: '{"en":"Cotton Swab","vi":"Bông ngoáy tai"}',
        path: 'dentist/Cotton_Swab.png',
        level: '5',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 225,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D26',
        word: '{"en":"Syringe","vi":"Ống tiêm"}',
        path: 'dentist/Syringe.png',
        level: '6',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 226,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D27',
        word: '{"en":"Tweezers","vi":"Cái nhíp"}',
        path: 'dentist/Tweezers.png',
        level: '7',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 227,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D28',
        word: '{"en":"Comb","vi":"Cái lược"}',
        path: 'dentist/Comb.png',
        level: '8',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 228,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D29',
        word: '{"en":"Facecloth","vi":"Khăn mặt"}',
        path: 'dentist/Facecloth.png',
        level: '9',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 229,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D30',
        word: '{"en":"Mouthwash","vi":"Nước súc miệng"}',
        path: 'dentist/Mouthwash.png',
        level: '10',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 230,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D31',
        word: '{"en":"Soap","vi":"Xà phòng"}',
        path: 'dentist/Soap.png',
        level: '11',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 231,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D32',
        word: '{"en":"Towel","vi":"Khăn tắm"}',
        path: 'dentist/Towel.png',
        level: '12',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 232,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D33',
        word: '{"en":"Tartar Scraper","vi":"Dụng cụ cạo răng"}',
        path: 'dentist/Tartar_Scraper.png',
        level: '13',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 233,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D34',
        word: '{"en":"Liquid Handwash","vi":"Nước rửa tay"}',
        path: 'dentist/Liquid_Handwash.png',
        level: '14',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 234,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D35',
        word: '{"en":"Shampoo","vi":"Dầu gội đầu"}',
        path: 'dentist/Shampoo.png',
        level: '15',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 235,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D36',
        word: '{"en":"Sink","vi":"Bồn rửa mặt"}',
        path: 'dentist/Sink.png',
        level: '16',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 236,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D37',
        word: '{"en":"Capsule","vi":"Thuốc con nhộng"}',
        path: 'dentist/Capsule.png',
        level: '17',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 237,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D38',
        word: '{"en":"Handkerchief","vi":"Khăn tay"}',
        path: 'dentist/Handkerchief.png',
        level: '18',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 238,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D39',
        word: '{"en":"Shower Gel","vi":"Sữa tắm"}',
        path: 'dentist/Shower_Gel.png',
        level: '19',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 239,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D40',
        word: '{"en":"Conditional","vi":"Dầu xả"}',
        path: 'dentist/Conditional.png',
        level: '20',
        map: '4',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 240,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D41',
        word: '{"en":"Fang","vi":"Răng nanh"}',
        path: 'dentist/Fang.png',
        level: '1',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 241,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D42',
        word: '{"en":"Molar","vi":"Răng hàm"}',
        path: 'dentist/Molar.png',
        level: '2',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 242,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D43',
        word: '{"en":"Decay","vi":"Sâu răng"}',
        path: 'dentist/Decay.png',
        level: '3',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 243,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D44',
        word: '{"en":"Cup","vi":"Cái cốc"}',
        path: 'dentist/Cup.png',
        level: '4',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 244,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D45',
        word: '{"en":"Tongue Cleaner","vi":"Dụng cụ làm sạch lưỡi"}',
        path: 'dentist/Tongue_Cleaner.png',
        level: '5',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 245,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D46',
        word: '{"en":"Cheek Retractor","vi":"Cheek Retractor"}',
        path: 'dentist/Cheek_Retractor.png',
        level: '6',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 246,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D47',
        word: '{"en":"Bath","vi":"Bồn tắm"}',
        path: 'dentist/Bath.png',
        level: '7',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 247,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D48',
        word: '{"en":"Brush The Teeth","vi":"Đánh răng"}',
        path: 'dentist/Brush_The_Teeth.png',
        level: '8',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 248,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D49',
        word: '{"en":"Wash The Face","vi":"Rửa mặt"}',
        path: 'dentist/Wash_The_Face.png',
        level: '9',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 249,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D50',
        word: '{"en":"Chipped Tooth","vi":"Răng sứt"}',
        path: 'dentist/Chipped_Tooth.png',
        level: '10',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 250,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D51',
        word: '{"en":"Dental Chair","vi":"Ghế nha khoa"}',
        path: 'dentist/Dental_Chair.png',
        level: '11',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 251,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D52',
        word: '{"en":"Dental Clinic","vi":"Phòng khám nha khoa"}',
        path: 'dentist/Dental_Clinic.jpg',
        level: '12',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 252,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D53',
        word: '{"en":"Tap","vi":"Vòi nước"}',
        path: 'dentist/Tap.png',
        level: '13',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 253,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D54',
        word: '{"en":"Shower","vi":"Vòi sen"}',
        path: 'dentist/Shower.png',
        level: '14',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 254,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D55',
        word: '{"en":"Dental Forceps","vi":"Kẹp răng"}',
        path: 'dentist/Dental_Forceps.png',
        level: '15',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 255,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D56',
        word: '{"en":"Hairbrush","vi":"Bàn chải tóc"}',
        path: 'dentist/Hairbrush.png',
        level: '16',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 256,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D57',
        word: '{"en":"Hygienist","vi":"chuyên viên vệ sinh răng"}',
        path: 'dentist/Hygienist.png',
        level: '17',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 257,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D58',
        word: '{"en":"Baby Powder","vi":"Phấn rôm"}',
        path: 'dentist/Baby_Powder.png',
        level: '18',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 258,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D59',
        word: '{"en":"Scissors","vi":"cái kéo"}',
        path: 'dentist/Scissors.png',
        level: '19',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 259,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D60',
        word: '{"en":"Dryer","vi":"Máy sấy"}',
        path: 'dentist/Dryer.png',
        level: '20',
        map: '3',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 260,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D61',
        word: '{"en":"Bathroom","vi":"Nhà tắm"}',
        path: 'dentist/Bathroom.jpg',
        level: '1',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 261,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D62',
        word: '{"en":"Alignment","vi":"Thẳng hàng"}',
        path: 'dentist/Alignment.png',
        level: '2',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 262,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D63',
        word: '{"en":"Medicine box","vi":"Hòm thuốc"}',
        path: 'dentist/Medicine_box.png',
        level: '3',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 263,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D64',
        word: '{"en":"Bacteria","vi":"Vi khuẩn"}',
        path: 'dentist/Bacteria.png',
        level: '4',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 264,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D65',
        word: '{"en":"Stethoscope","vi":"Ống nghe"}',
        path: 'dentist/Stethoscope.png',
        level: '5',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 265,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D66',
        word: '{"en":"Microscope","vi":"Kính hiển vi"}',
        path: 'dentist/Microscope.png',
        level: '6',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 266,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D67',
        word: '{"en":"Suture","vi":"Chỉ khâu"}',
        path: 'dentist/Suture.png',
        level: '7',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 267,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D68',
        word: '{"en":"Smile","vi":"Nụ cười"}',
        path: 'dentist/Smile.png',
        level: '8',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 268,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D69',
        word: '{"en":"Whiten","vi":"Làm trắng"}',
        path: 'dentist/Whiten.png',
        level: '9',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 269,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D70',
        word: '{"en":"Cavity","vi":"Hổng răng"}',
        path: 'dentist/Cavity.png',
        level: '10',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 270,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D71',
        word: '{"en":"X-ray","vi":"X quang"}',
        path: 'dentist/X_ray.png',
        level: '11',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 271,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D72',
        word: '{"en":"Dental","vi":"Nha khoa"}',
        path: 'dentist/Dental.png',
        level: '12',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 272,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D73',
        word: '{"en":"Fear","vi":"Sợ hãi"}',
        path: 'dentist/Fear.png',
        level: '13',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 273,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D74',
        word: '{"en":"Medication","vi":"Thuốc"}',
        path: 'dentist/Medication.png',
        level: '14',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 274,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D75',
        word: '{"en":"Needle","vi":"Mũi kim"}',
        path: 'dentist/Needle.png',
        level: '15',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 275,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D76',
        word: '{"en":"Goggle","vi":"Kính bảo hộ"}',
        path: 'dentist/Goggle.png',
        level: '16',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 276,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D77',
        word: '{"en":"Orthodontist","vi":"Bác sĩ chỉnh răng"}',
        path: 'dentist/Orthodontist.png',
        level: '17',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 277,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D78',
        word: '{"en":"Worried","vi":"Lo lắng"}',
        path: 'dentist/Worried.png',
        level: '18',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 278,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D79',
        word: '{"en":"Health insurance","vi":"Bảo hiểm y tế"}',
        path: 'dentist/Health_insurance.png',
        level: '19',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 279,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D80',
        word: '{"en":"Thermometer","vi":"Nhiệt kế"}',
        path: 'dentist/Thermometer.png',
        level: '20',
        map: '1',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 280,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D81',
        word: '{"en":"Check up","vi":"Khám"}',
        path: 'dentist/Check_up.png',
        level: '1',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 281,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D82',
        word: '{"en":"Injection","vi":"Tiêm"}',
        path: 'dentist/Injection.png',
        level: '2',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 282,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D83',
        word: '{"en":"Notepad","vi":"Ghi chú y tế"}',
        path: 'dentist/Notepad.png',
        level: '3',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 283,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D84',
        word: '{"en":"Medical mask","vi":"Khẩu trang y tế"}',
        path: 'dentist/Medical_mask.png',
        level: '4',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 284,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D85',
        word: '{"en":"Medicine cabinet","vi":"Tủ thuốc"}',
        path: 'dentist/Medicine_cabinet.png',
        level: '5',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 285,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D86',
        word: '{"en":"Blood bag","vi":"Túi máu"}',
        path: 'dentist/Blood_bag.png',
        level: '6',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 286,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D87',
        word: '{"en":"Gloves","vi":"Găng tay"}',
        path: 'dentist/Gloves.png',
        level: '7',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 287,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D88',
        word: '{"en":"Prescription","vi":"Đơn thuốc"}',
        path: 'dentist/Prescription.png',
        level: '8',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 288,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D89',
        word: '{"en":"Scalpel","vi":"Dao mổ"}',
        path: 'dentist/Scalpel.png',
        level: '9',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 289,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D90',
        word: '{"en":"Headlight","vi":"Đèn đội đầu"}',
        path: 'dentist/Headlight.png',
        level: '10',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 290,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D91',
        word: '{"en":"Medical bed","vi":"Giường bệnh"}',
        path: 'dentist/Medical_bed.png',
        level: '11',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 291,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D92',
        word: '{"en":"Strong teeth","vi":"Răng chắc khỏe"}',
        path: 'dentist/Strong_teeth.png',
        level: '12',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 292,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D93',
        word: '{"en":"Curious","vi":"Tò mò"}',
        path: 'dentist/Curious.png',
        level: '13',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 293,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D94',
        word: '{"en":"Washing mouth","vi":"Súc miệng"}',
        path: 'dentist/Washing_mouth.png',
        level: '14',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 294,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D95',
        word: '{"en":"Sit","vi":"Ngồi"}',
        path: 'dentist/Sit.png',
        level: '15',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 295,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D96',
        word: '{"en":"Lie","vi":"Nằm"}',
        path: 'dentist/Lie.png',
        level: '16',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 296,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D97',
        word: '{"en":"Dropper","vi":"Ống nhỏ giọt"}',
        path: 'dentist/Dropper.png',
        level: '17',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 297,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D98',
        word: '{"en":"Infusion","vi":"Truyền dịch"}',
        path: 'dentist/Infusion.png',
        level: '18',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 298,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D99',
        word: '{"en":"Band-aid","vi":"Băng cá nhân"}',
        path: 'dentist/Band_aid.png',
        level: '19',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 299,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'D100',
        word: '{"en":"Test tube","vi":"Ống nghiệm"}',
        path: 'dentist/Test_tube.png',
        level: '20',
        map: '2',
        topic: 'DENTIST',
        status: 'ACTIVE',
        id: 300,
        createdAt: '2019-09-28T06:53:34.000Z',
        updatedAt: '2019-10-03T18:29:33.000Z'
    },
    {
        name: 'T1',
        word: '{"en":"Car","vi":"Ô tô"}',
        path: 'traffic/Car.png',
        level: '1',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 301,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T2',
        word: '{"en":"Boat","vi":"Thuyền"}',
        path: 'traffic/Boat.png',
        level: '2',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 302,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T3',
        word: '{"en":"Truck","vi":"Xe tải"}',
        path: 'traffic/Truck.png',
        level: '3',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 303,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T4',
        word: '{"en":"Tricycle","vi":"Xe đạp 3 bánh"}',
        path: 'traffic/Tricycle.png',
        level: '4',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 304,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T5',
        word: '{"en":"Airplane","vi":"Máy bay"}',
        path: 'traffic/Airplane.png',
        level: '5',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 305,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T6',
        word: '{"en":"Sailboat","vi":"Thuyền buồm"}',
        path: 'traffic/Sailboat.png',
        level: '6',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 306,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T7',
        word: '{"en":"Hot Air Balloon","vi":"Khinh khí cầu"}',
        path: 'traffic/Balloon.png',
        level: '7',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 307,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T8',
        word: '{"en":"Cargo ship","vi":"Tàu chở hàng"}',
        path: 'traffic/Cargo_Ship.png',
        level: '8',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 308,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T9',
        word: '{"en":"Minivan","vi":"Xe tải nhỏ"}',
        path: 'traffic/Minivan.png',
        level: '9',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 309,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T10',
        word: '{"en":"Bicycle","vi":"Xe đạp"}',
        path: 'traffic/Bicycle.png',
        level: '10',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 310,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T11',
        word: '{"en":"Food truck","vi":"Xe thực phẩm"}',
        path: 'traffic/Food_Truck.png',
        level: '11',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 311,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T12',
        word: '{"en":"Tram","vi":"Tàu điện"}',
        path: 'traffic/Tram.png',
        level: '12',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 312,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T13',
        word: '{"en":"Motorcycle","vi":"Xe máy"}',
        path: 'traffic/Motorcycle.png',
        level: '13',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 313,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T14',
        word: '{"en":"Helicopter","vi":"Trực thăng"}',
        path: 'traffic/Helicopter.png',
        level: '14',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 314,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T15',
        word: '{"en":"School Bus","vi":"Xe buýt trường học"}',
        path: 'traffic/School_Bus.png',
        level: '15',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 315,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T16',
        word: '{"en":"Chariot","vi":"Xe ngựa"}',
        path: 'traffic/Chariot.png',
        level: '16',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 316,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T17',
        word: '{"en":"Rickshaw","vi":"Xe kéo"}',
        path: 'traffic/Rickshaw.png',
        level: '17',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 317,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T18',
        word: '{"en":"Train","vi":"Tàu hỏa"}',
        path: 'traffic/Train.png',
        level: '18',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 318,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T19',
        word: '{"en":"Yacht","vi":"Du thuyền"}',
        path: 'traffic/Yacht.png',
        level: '19',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 319,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T20',
        word: '{"en":"Coach","vi":"Xe khách"}',
        path: 'traffic/Coach.png',
        level: '20',
        map: '1',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 320,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T21',
        word: '{"en":"Firetruck","vi":"Xe cứu hỏa"}',
        path: 'traffic/Firetruck.png',
        level: '1',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 321,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T22',
        word: '{"en":"Tractor","vi":"Máy kéo nông nghiệp"}',
        path: 'traffic/Tractor.png',
        level: '2',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 322,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T23',
        word: '{"en":"Forklift","vi":"Xe nâng"}',
        path: 'traffic/Forklift.png',
        level: '3',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 323,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T24',
        word: '{"en":"Dump truck","vi":"Xe ben"}',
        path: 'traffic/Dump_Truck.png',
        level: '4',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 324,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T25',
        word: '{"en":"Taxi","vi":"Xe taxi"}',
        path: 'traffic/Taxi.png',
        level: '5',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 325,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T26',
        word: '{"en":"Sports car","vi":"Xe thể thao"}',
        path: 'traffic/Sports_Car.png',
        level: '6',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 326,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T27',
        word: '{"en":"Police car","vi":"Xe cảnh sát"}',
        path: 'traffic/Police_Car.png',
        level: '7',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 327,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T28',
        word: '{"en":"Cyclo","vi":"Xe Xích Lô"}',
        path: 'traffic/Cyclo.png',
        level: '8',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 328,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T29',
        word: '{"en":"Ambulance","vi":"Xe cứu thương"}',
        path: 'traffic/Ambulance.png',
        level: '9',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 329,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T30',
        word: '{"en":"Submarine","vi":"Tàu ngầm"}',
        path: 'traffic/Submarine.png',
        level: '10',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 330,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T31',
        word: '{"en":"Rocket","vi":"Tên lửa"}',
        path: 'traffic/Rocket.png',
        level: '11',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 331,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T32',
        word: '{"en":"Pickup truck","vi":"Xe bán tải"}',
        path: 'traffic/Pickup_Truck.png',
        level: '12',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 332,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T33',
        word: '{"en":"Garbage truck","vi":"Xe chở rác"}',
        path: 'traffic/Garbage_Truck.png',
        level: '13',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 333,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T34',
        word: '{"en":"Concrete mixer truck","vi":"Xe trộn bê tông"}',
        path: 'traffic/Concrete_Mixer_Truck.png',
        level: '14',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 334,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T35',
        word: '{"en":"Railway","vi":"Đường sắt"}',
        path: 'traffic/Railway.png',
        level: '15',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 335,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T36',
        word: '{"en":"Military truck","vi":"Xe tải quân sự"}',
        path: 'traffic/Military_Truck.png',
        level: '16',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 336,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T37',
        word: '{"en":"Unicycle","vi":"Xe đạp 1 bánh"}',
        path: 'traffic/Unicycle.png',
        level: '17',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 337,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T38',
        word: '{"en":"Harrier jet","vi":"Máy bay phản lực"}',
        path: 'traffic/Harrier_Jet.jpg',
        level: '18',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 338,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T39',
        word: '{"en":"Container ship","vi":"Tàu container"}',
        path: 'traffic/Container_Ship.png',
        level: '19',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 339,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T40',
        word: '{"en":"Bus double decker","vi":"Xe buýt 2 tầng"}',
        path: 'traffic/Bus_Double_Decker.png',
        level: '20',
        map: '2',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 340,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T41',
        word: '{"en":"No Motorcycle","vi":"Cấm xe máy"}',
        path: 'traffic/No_Motorcycle.png',
        level: '1',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 341,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T42',
        word: '{"en":"No parking","vi":"Cấm đỗ xe"}',
        path: 'traffic/No_Parking.png',
        level: '2',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 342,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T43',
        word: '{"en":"Turn right","vi":"Rẽ phải"}',
        path: 'traffic/Turn_Right.png',
        level: '3',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 343,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T44',
        word: '{"en":"Signpost","vi":"Biển báo"}',
        path: 'traffic/Signpost.png',
        level: '4',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 344,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T45',
        word: '{"en":"No horn","vi":"Cấm còi"}',
        path: 'traffic/No_Horn.png',
        level: '5',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 345,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T46',
        word: '{"en":"Go straight","vi":"Đi thẳng"}',
        path: 'traffic/Go_Straight.png',
        level: '6',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 346,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T47',
        word: '{"en":"One-way street","vi":"Đường 1 chiều"}',
        path: 'traffic/One_Way_Street.png',
        level: '7',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 347,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T48',
        word: '{"en":"Turn left","vi":"Rẽ trái"}',
        path: 'traffic/Turn_Left.png',
        level: '8',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 348,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T49',
        word: '{"en":"Parking","vi":"Được phép đỗ xe"}',
        path: 'traffic/Parking.jpg',
        level: '9',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 349,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T50',
        word: '{"en":"Prohibition sign","vi":"Biển báo cấm"}',
        path: 'traffic/Prohibition_Sign.png',
        level: '10',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 350,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T51',
        word: '{"en":"No car","vi":"Cấm ô tô"}',
        path: 'traffic/No_Car.png',
        level: '11',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 351,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T52',
        word: '{"en":"Space shuttle","vi":"Tàu con thoi"}',
        path: 'traffic/Space_Shuttle.jpg',
        level: '12',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 352,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T53',
        word: '{"en":"Spaceship","vi":"Tàu không gian"}',
        path: 'traffic/Spaceship.png',
        level: '13',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 353,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T54',
        word: '{"en":"Hydraulic crawler crane","vi":"Cần cẩu thủy lực"}',
        path: 'traffic/Hydraulic_Crawler_Crane.png',
        level: '14',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 354,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T55',
        word: '{"en":"Petrol station","vi":"Trạm xăng"}',
        path: 'traffic/Petrol_Station.png',
        level: '15',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 355,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T56',
        word: '{"en":"Ferry","vi":"Phà"}',
        path: 'traffic/Ferry.png',
        level: '16',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 356,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T57',
        word: '{"en":"Hydraulic hammer","vi":"Búa thủy lực"}',
        path: 'traffic/Hydraulic_Hammer.png',
        level: '17',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 357,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T58',
        word: '{"en":"Pirate ship","vi":"Tàu cướp biển"}',
        path: 'traffic/Pirate_Ship.png',
        level: '18',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 358,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T59',
        word: '{"en":"Limousine","vi":"Xe limousine"}',
        path: 'traffic/Limousine.png',
        level: '19',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 359,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T60',
        word: '{"en":"Coffee cart","vi":"Xe cà phê"}',
        path: 'traffic/Coffee_Cart.png',
        level: '20',
        map: '3',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 360,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T61',
        word: '{"en":"Tank","vi":"Xe tăng"}',
        path: 'traffic/Tank.png',
        level: '1',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 361,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T62',
        word: '{"en":"Container truck","vi":"Xe container"}',
        path: 'traffic/Container_Truck.png',
        level: '2',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 362,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T63',
        word: '{"en":"Traffic light","vi":"Đèn giao thông"}',
        path: 'traffic/Traffic_Light.png',
        level: '3',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 363,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T64',
        word: '{"en":"Bridge","vi":"Cầu"}',
        path: 'traffic/Bridge.png',
        level: '4',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 364,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T65',
        word: '{"en":"Construction cranes","vi":"Xe cần cẩu"}',
        path: 'traffic/Construction_Cranes.png',
        level: '5',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 365,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T66',
        word: '{"en":"Farm truck","vi":"Xe tải nông trại"}',
        path: 'traffic/Farm_Truck.png',
        level: '6',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 366,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T67',
        word: '{"en":"Steamboat","vi":"Tàu hơi nước"}',
        path: 'traffic/Steamboat.png',
        level: '7',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 367,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T68',
        word: '{"en":"Glider","vi":"Tàu lượn"}',
        path: 'traffic/Glider.jpg',
        level: '8',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 368,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T69',
        word: '{"en":"Rowing boat","vi":"Thuyền có mái chèo"}',
        path: 'traffic/Rowing_Boat.png',
        level: '9',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 369,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T70',
        word: '{"en":"Speedboat","vi":"Tàu siêu tốc"}',
        path: 'traffic/Speedboat.png',
        level: '10',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 370,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T71',
        word: '{"en":"Concrete pump truck","vi":"Xe bơm bê tông"}',
        path: 'traffic/Concrete_Pump_Truck.png',
        level: '11',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 371,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T72',
        word: '{"en":"Grader","vi":"Xe ban"}',
        path: 'traffic/Grader.png',
        level: '12',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 372,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T73',
        word: '{"en":"Excavators","vi":"Máy xúc"}',
        path: 'traffic/Excavators.png',
        level: '13',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 373,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T74',
        word: '{"en":"Wheel","vi":"Bánh xe"}',
        path: 'traffic/Wheel.png',
        level: '14',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 374,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T75',
        word: '{"en":"Road Blocker","vi":"Chặn đường"}',
        path: 'traffic/Road_Blocker.png',
        level: '15',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 375,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T76',
        word: '{"en":"Clamshell","vi":"Xe cẩu cạp"}',
        path: 'traffic/Clamshell.png',
        level: '16',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 376,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T77',
        word: '{"en":"Lifting machine","vi":"máy nâng"}',
        path: 'traffic/Lifting_Machine.png',
        level: '17',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 377,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T78',
        word: '{"en":"Lifeboat","vi":"thuyền cứu sinh"}',
        path: 'traffic/Lifeboat.png',
        level: '18',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 378,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T79',
        word: '{"en":"Jet ski","vi":""}',
        path: 'traffic/Jet_Ski.png',
        level: '19',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 379,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T80',
        word: '{"en":"Seaplane","vi":""}',
        path: 'traffic/Seaplane.png',
        level: '20',
        map: '4',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 380,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T81',
        word: '{"en":"Bus","vi":"Xe buýt"}',
        path: 'traffic/Bus.png',
        level: '1',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 381,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T82',
        word: '{"en":"Steam roller","vi":"Xe lu"}',
        path: 'traffic/Steam_Roller.png',
        level: '2',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 382,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T83',
        word: '{"en":"Bulldozer","vi":"Xe ủi"}',
        path: 'traffic/Bulldozer.png',
        level: '3',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 383,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T84',
        word: '{"en":"Tank truck","vi":"Xe bồn"}',
        path: 'traffic/Tank_Truck.png',
        level: '4',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 384,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T85',
        word: '{"en":"Jeep","vi":"Xe jeep"}',
        path: 'traffic/Jeep.png',
        level: '5',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 385,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T86',
        word: '{"en":"Ice cream truck","vi":"Xe chở kem"}',
        path: 'traffic/Ice_Cream_Truck.png',
        level: '6',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 386,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T87',
        word: '{"en":"Cable car","vi":"Cáp treo"}',
        path: 'traffic/Cable_Car.png',
        level: '7',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 387,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T88',
        word: '{"en":"Bus shelters","vi":"Trạm dừng xe buýt"}',
        path: 'traffic/Bus_Shelters.png',
        level: '8',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 388,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T89',
        word: '{"en":"Sleigh","vi":"Xe trượt tuyết"}',
        path: 'traffic/Sleigh.png',
        level: '9',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 389,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T90',
        word: '{"en":"Subway","vi":"Tàu điện ngầm"}',
        path: 'traffic/Subway.png',
        level: '10',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 390,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T91',
        word: '{"en":"Tower crane","vi":"Cẩu tháp"}',
        path: 'traffic/Tower_Crane.png',
        level: '11',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 391,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T92',
        word: '{"en":"Loader crane","vi":"Cần cẩu gấp"}',
        path: 'traffic/Loader_Crane.png',
        level: '12',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 392,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T93',
        word: '{"en":"Backhoe","vi":"Xe cuốc"}',
        path: 'traffic/Backhoe.png',
        level: '13',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 393,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T94',
        word: '{"en":"Racecar","vi":"Xe đua"}',
        path: 'traffic/Racecar.png',
        level: '14',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 394,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T95',
        word: '{"en":"Mountain bike","vi":"Xe đạp địa hình"}',
        path: 'traffic/Mountain_Bike.png',
        level: '15',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 395,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T96',
        word: '{"en":"Helmet","vi":"Mũ bảo hiểm"}',
        path: 'traffic/Helmet.png',
        level: '16',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 396,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T97',
        word: '{"en":"UFO","vi":"Đĩa bay"}',
        path: 'traffic/UFO.png',
        level: '17',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 397,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T98',
        word: '{"en":"Monster truck","vi":"Xe tải hạng nặng"}',
        path: 'traffic/Monster_Truck.png',
        level: '18',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 398,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T99',
        word: '{"en":"Electric bicycle","vi":"xe đạp điện"}',
        path: 'traffic/Electric_Bicycle.png',
        level: '19',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 399,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    },
    {
        name: 'T100',
        word: '{"en":"Push cart","vi":"Xe đẩy"}',
        path: 'traffic/Push_Cart.png',
        level: '20',
        map: '5',
        topic: 'TRAFFIC',
        status: 'ACTIVE',
        id: 400,
        createdAt: '2019-09-23T14:30:00.000Z',
        updatedAt: '2019-09-28T04:41:07.000Z'
    }
];
